import { FC, useContext, useEffect } from 'react';

import mixpanel from 'mixpanel-browser';

import { trackCometlyFactFindSubmitted } from '@App/cometly/cometly';
import { ApplicationContext } from '@App/contexts/Application';
import { ExperimentsConfig } from '@App/utils/experiments';
import useConversionTracking from '@src/app/hooks/useConversionTracking';

import WaitLayout from '../layouts/WaitLayout';
import WaitView from '../views/wait/WaitView';

const Wait: FC = () => {
    const {
        setOffers,
        setApplicationStage,
        runDecisioning,
        fetchApplication,
        runCreditCommitments,
        applicationId,
        applicationEmail,
        loanDetails,
        saveFinalStage,
        deferredApplicant2TestUser,
    } = useContext(ApplicationContext);

    useConversionTracking(applicationEmail, 351873);

    useEffect(() => {
        const shouldSendVariant = deferredApplicant2TestUser !== null;

        mixpanel.track('Submit Fact Find', {
            'Loan amount': loanDetails.amount,
            'Loan term': loanDetails.term,
            'Loan purpose': loanDetails.purpose,
            ...(shouldSendVariant && {
                a2_defer_variant: deferredApplicant2TestUser
                    ? ExperimentsConfig.Variants.B
                    : ExperimentsConfig.Variants.A,
            }),
        });
    }, [
        loanDetails.amount,
        loanDetails.term,
        loanDetails.purpose,
        deferredApplicant2TestUser,
    ]);

    useEffect(() => {
        trackCometlyFactFindSubmitted(applicationId, applicationEmail);
    }, [applicationId, applicationEmail]);

    return (
        <WaitLayout>
            <WaitView
                fetchApplication={fetchApplication}
                setOffers={setOffers}
                setApplicationStage={setApplicationStage}
                runDecisioning={runDecisioning}
                runCreditCommitments={runCreditCommitments}
                applicationId={applicationId}
                saveFinalStage={saveFinalStage}
            />
        </WaitLayout>
    );
};

export default Wait;
